export default "__VITE_ASSET__DF$1WzZQ__"